import { ProductAnalyticsModel } from "lib/@types/service/product/shared";

export const $WishlistModalModuleName = "wishlistModal";

export type WishlistModalProduct = {
    sku: string;
    ean: string;
    productTitle: string;
    brandName?: string;
    analytics?: ProductAnalyticsModel;
    currentPrice?: number | null;
    roundedDiscountPercentage?: number | null;
};

export interface TWishlistModalState {
    visible: boolean;
    product?: WishlistModalProduct;
}
